import { Section } from '@policygenius/dif-ts-types';

const financesSchema: Section = {
  nodeType: 'SECTION',
  urn: 'urn:pg:interview:section:continue-online-financial-profile',
  content: '',
  rules: { operation: '=', field: 'children.all.valid', value: true },
  presentationRules: {
    section_bankruptcy_followup: {
      field: 'question_insured_risk_activity_bankruptcy.value',
      value: true,
      operation: '=',
    },
    section_adverse_insurance_history_followup: {
      field: 'question_insured_adverse_insurance_history.value',

      value: true,
      operation: '=',
    },
  },
  children: [
    {
      nodeType: 'QUESTION',
      questionType: 'BOOLEAN',
      urn: 'urn:pg:interview:question:insured-risk-activity-bankruptcy',
      dataPoint: {
        dataType: 'boolean',
        urn: 'urn:pg:data-point:insured-risk-activity-bankruptcy',
      },
      content:
        'Have you ever filed for bankruptcy or had any judgments/liens filed against you? Or do you intend to seek bankruptcy protection within the next 12 months?',
      rules: { field: 'value.present', value: true, operation: '=' },
    },
    {
      nodeType: 'SECTION',
      urn: 'urn:pg:interview:section:bankruptcy-followup',
      content: '',
      rules: { operation: '=', field: 'children.all.valid', value: true },
      children: [
        {
          nodeType: 'QUESTION',
          questionType: 'SINGLE_CHOICE',
          urn: 'urn:pg:interview:question:insured-risk-activity-bankruptcy-chapter-filed',
          dataPoint: {
            dataType: 'integer',
            urn: 'urn:pg:data-point:insured-risk-activity-bankruptcy-chapter-filed',
          },
          choices: [
            { value: 7, displayText: 'Chapter 7' },
            { value: 11, displayText: 'Chapter 11' },
            { value: 12, displayText: 'Chapter 12' },
            { value: 13, displayText: 'Chapter 13' },
            { value: 15, displayText: 'Chapter 15' },
          ],
          content: 'Bankruptcy chapter filed',
          rules: { field: 'value.present', value: true, operation: '=' },
        },
        {
          nodeType: 'QUESTION',
          questionType: 'DATE',
          urn: 'urn:pg:interview:question:insured-risk-activity-bankruptcy-filed-date',
          dataPoint: {
            dataType: 'date',
            urn: 'urn:pg:data-point:insured-risk-activity-bankruptcy-filed-date',
          },
          content: 'Date filed',
          rules: { field: 'value.present', value: true, operation: '=' },
        },
        {
          nodeType: 'QUESTION',
          questionType: 'DATE',
          urn: 'urn:pg:interview:question:insured-risk-activity-bankruptcy-discharged-date',
          dataPoint: {
            dataType: 'date',
            urn: 'urn:pg:data-point:insured-risk-activity-bankruptcy-discharged-date',
          },
          content: 'Date discharged',
          rules: { field: 'value.present', value: true, operation: '=' },
        },
        {
          nodeType: 'QUESTION',
          questionType: 'TEXT',
          urn: 'urn:pg:interview:question:insured-risk-activity-bankruptcy-reason',
          dataPoint: {
            dataType: 'text',
            subtype: 'long_text',
            urn: 'urn:pg:data-point:insured-risk-activity-bankruptcy-reason',
          },
          content: 'Please specify the reason(s) for bankruptcy.',
          rules: { field: 'value.present', value: true, operation: '=' },
        },
      ],
    },
    {
      nodeType: 'QUESTION',
      questionType: 'BOOLEAN',
      urn: 'urn:pg:interview:question:insured-wage-replacement-history',
      dataPoint: {
        dataType: 'boolean',
        urn: 'urn:pg:data-point:insured-wage-replacement-history',
      },
      content:
        "In the past 5 years, have you requested or received a workers' compensation, Social Security, or disability income payment?",
      rules: { field: 'value.present', value: true, operation: '=' },
    },
    {
      nodeType: 'QUESTION',
      questionType: 'BOOLEAN',
      urn: 'urn:pg:interview:question:insured-adverse-insurance-history',
      dataPoint: {
        dataType: 'boolean',
        urn: 'urn:pg:data-point:insured-adverse-insurance-history',
      },
      content:
        'Have you ever had an application for life insurance modified, rated, declined, postponed, canceled, or restricted in any way?',
      rules: { field: 'value.present', value: true, operation: '=' },
    },
    {
      nodeType: 'SECTION',
      urn: 'urn:pg:interview:section:adverse-insurance-history-followup',
      content: '',
      rules: { operation: '=', field: 'children.all.valid', value: true },
      children: [
        {
          nodeType: 'QUESTION',
          questionType: 'TEXT',
          urn: 'urn:pg:interview:question:insured-adverse-insurance-history-coverage-type',
          dataPoint: {
            dataType: 'text',
            urn: 'urn:pg:data-point:insured-adverse-insurance-history-coverage-type',
          },
          content: 'Type of coverage',
          rules: { field: 'value.present', value: true, operation: '=' },
        },
        {
          nodeType: 'QUESTION',
          questionType: 'DATE',
          urn: 'urn:pg:interview:question:insured-adverse-insurance-history-date',
          dataPoint: {
            dataType: 'date',
            urn: 'urn:pg:data-point:insured-adverse-insurance-history-date',
          },
          content: 'Date',
          rules: { field: 'value.present', value: true, operation: '=' },
        },
        {
          nodeType: 'QUESTION',
          questionType: 'TEXT',
          urn: 'urn:pg:interview:question:insured-adverse-insurance-history-reason',
          dataPoint: {
            dataType: 'text',
            subtype: 'long_text',
            urn: 'urn:pg:data-point:insured-adverse-insurance-history-reason',
          },
          content:
            'Why was your application for life insurance modified, rated, declined, postponed, canceled, or restricted?',
          rules: { field: 'value.present', value: true, operation: '=' },
        },
      ],
    },
    {
      nodeType: 'QUESTION',
      questionType: 'BOOLEAN',
      urn: 'urn:pg:interview:question:insured-subject-to-backup-withholding',
      dataPoint: {
        dataType: 'boolean',
        urn: 'urn:pg:data-point:insured-subject-to-backup-withholding',
      },
      content:
        'Are you subject to backup withholding from the IRS for failing to report interest or dividends?',
      rules: { field: 'value.present', value: true, operation: '=' },
    },
  ],
};

export default financesSchema;
